export const PKG_ERROR_TYPES = {
  HTL_CART_ERR: 'HTL_CART_ERR',
  PKG_SEARCH_EMPTY_OR_INVALID_CART: 'PKG_SEARCH-emptyOrInvalidCart',
  PKG_FLIGHT_ERROR: 'PKG_FLIGHT_ERROR',
  GET_USP_VEHICLES_ERROR: 'GET_USP_VEHICLES_ERROR',
} as const

export type PkgErrorType = (typeof PKG_ERROR_TYPES)[keyof typeof PKG_ERROR_TYPES]

export const ERROR_TYPE_GA4_MAP: Record<PkgErrorType, string> = {
  [PKG_ERROR_TYPES.HTL_CART_ERR]: 'pkg_landing_htl_cart_search_error',
  [PKG_ERROR_TYPES.PKG_SEARCH_EMPTY_OR_INVALID_CART]: 'pkg_landing_empty_cart_search_error',
  [PKG_ERROR_TYPES.PKG_FLIGHT_ERROR]: 'pkg_landing_fly_error_search_error',
  [PKG_ERROR_TYPES.GET_USP_VEHICLES_ERROR]: 'pkg_landing_usp_rc_search_error',
}

export const IMPRESSION_ELIGIBLE_ERRORS: readonly PkgErrorType[] = [
  PKG_ERROR_TYPES.HTL_CART_ERR,
  PKG_ERROR_TYPES.PKG_SEARCH_EMPTY_OR_INVALID_CART,
  PKG_ERROR_TYPES.PKG_FLIGHT_ERROR,
  PKG_ERROR_TYPES.GET_USP_VEHICLES_ERROR,
]
